import { Slide } from "@jelly/lesson";
import { task as task01 } from "../../../../../task/course-02/lesson-02/task-01";

const task: Slide = {
  title: `Connect the parts of the brain that are directly connected to each other for the processing of acoustic signals.`,
  description: "Connect with lines.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
